// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/fuel.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/fuel/fuel.js';

mount([g0]);
